export default "__VITE_ASSET__CmQ4Rzx___"